import { useState, useRef, useCallback, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, TextField } from "@mui/material";
import AppBackService from "../services/appback";
import { RootContext } from "../context/root-provider";

const styles = {
  textField: {
    width: "100%",
    marginBottom: "10px",
    marginTop: "6px",
  },
  heading: {
    marginTop: "10px",
  },
};

const StartYTTranscribeModal = ({ open, setOpen, presetUrl, refreshCallback, showSnackbar }) => {
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [formInvalid, setFormInvalid] = useState(false);
  const dialogContentEl = useRef();

  const { userInfo } = useContext(RootContext);

  // A link handed in from outside (dropped, pasted, or on the clipboard —
  // TT-1231) fills the field on open; the user still presses Start.
  useEffect(() => {
    if (open && presetUrl) setYoutubeUrl(presetUrl);
  }, [open, presetUrl]);

  const closeModal = useCallback(() => {
    setFormInvalid(false);
    setOpen(false);
    setYoutubeUrl("");
  }, [setOpen]);

  const startYTTranscribe = useCallback(async () => {
    if (!youtubeUrl) {
      setFormInvalid(true);
      return;
    } else {
      setFormInvalid(false);
    }
    const resp = await AppBackService.startYTTranscribe(userInfo?.username, youtubeUrl);
    if (resp && !resp.error) {
      showSnackbar("YouTube transcription started!", "success");
      refreshCallback && refreshCallback();
    } else {
      showSnackbar("Unable to start YouTube transcription", "error");
    }
    setOpen(false);
    setYoutubeUrl("");
  }, [youtubeUrl, userInfo, showSnackbar, setOpen, refreshCallback]);

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={closeModal}>
      <DialogTitle>YouTube Transcription</DialogTitle>
      <DialogContent ref={dialogContentEl}>
        <DialogContentText sx={styles.heading}>Enter the YouTube URL to start transcription.</DialogContentText>
        <TextField
          sx={styles.textField}
          error={formInvalid && !youtubeUrl}
          helperText={formInvalid && !youtubeUrl && "Please enter a YouTube URL"}
          placeholder="YouTube URL"
          value={youtubeUrl}
          onChange={(e) => setYoutubeUrl(e.target.value)}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal}>Cancel</Button>
        <Button onClick={startYTTranscribe}>Start</Button>
      </DialogActions>
    </Dialog>
  );
};

StartYTTranscribeModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  presetUrl: PropTypes.string,
  refreshCallback: PropTypes.func,
  showSnackbar: PropTypes.func,
};

export default StartYTTranscribeModal;
